<template>
  <v-card flat>
    <v-card-title>
      <span class="headline">Register</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" @submit.prevent="register" v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="username"
                label="Username"
                name="username"
                value
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="First name"
                required
                v-model="firstName"
                name="firstName"
                value
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="surname"
                name="surname"
                label="Last Name"
                required
                value
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="email"
                label="Email"
                name="email"
                :rules="rules.emailRules"
                value
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="password"
                label="Password"
                name="password"
                type="password"
                :rules="[rules.required, rules.min, passwordConfirmRule]"
                value
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="confirmPassword"
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                value
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="institution"
                :items="institutionData"
                item-text="title"
                item-value="title"
                label="Institution"
                clearable
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-checkbox
                v-model="checkbox"
                label="Accept Terms of Use"
                :rules="[rules.required]"
              ></v-checkbox>
              <p>
                By ticking the box and clicking the "Agree and Create Account"
                button, I agree and consent to Hire Next Generation's
                <router-link to="terms-and-conditions"
                  >Terms of Use</router-link
                >
                and
                <router-link to="privacy-policy">Privacy Policy</router-link>.
              </p>
            </v-col>

            <v-btn
              type="submit"
              :disabled="!valid"
              color="#FC4A46"
              class="register"
              >Agree and Create Account</v-btn
            >
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-snackbar v-model="snackbar" dark color="#0274b3" timeout="-1" centered>
      You have successfully registered! Please login to view your profile.

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarError" dark color="#0274b3" centered>
      Something went wrong. This username/email may already exist.

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbarError = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import institutionJson from '../../data/institutions.json';

export default {
  data: () => ({
    snackbar: false,
    snackbarError: false,
    dialog: false,
    firstName: '',
    surname: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    userExists: false,
    registerSuccess: false,
    valid: false,
    institution: '',
    institutionData: institutionJson,
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
    },
  }),
  props: ['buttonText', 'color', 'dark', 'text'],
  methods: {
    handleOpenSnackBar() {
      this.snackbar = true;
      this.dialog = false;
    },
    resetAllFields() {
      this.firstName = '';
      this.surname = '';
      this.username = '';
      this.email = '';
      this.password = '';
      this.confirmPassword = '';
      this.institution = '';
      this.username = '';
    },
    register() {
      const self = this;
      if (this.$refs.form.validate()) {
        console.log('register');
        this.$store
          .dispatch('REGISTER', {
            username: this.username,
            email: this.email,
            password: this.password,
            type: 'candidate',
            firstName: this.firstName,
            surname: this.surname,
            institution: this.institution,
          })
          .then((success) => {
            console.log(success);
            this.registerSuccess = true;
            console.log('Candidate Created!');
            self.handleOpenSnackBar();
            self.resetAllFields();
          })
          .catch((error) => {
            console.log(error);
            this.userExists = true;
          });
      }
    },
  },
  computed: {
    passwordConfirmRule() {
      return this.password === this.confirmPassword || 'Password must match';
    },
  },
};
</script>

<style lang="scss">
.register span {
  color: white;
}
</style>
